<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @print="print" @imp="impx" @del="del"
                    @execute="excute" @save="save" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="InvReceieveManufactureViewInfo"
                        :filter_language="['negative_flag','Order_Status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="edits"
                        @rowdblclick="openEdit"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        @row-click="edits"
                        @row-dblclick="openEdit"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        ref="singleTable"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No"
                                     :label="$t('getapi[2095]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[552]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Receive_type"
                                     :label="$t('getapi[2097]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_account_no"
                                     :label="$t('getapi[2098]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_person"
                                     :label="$t('getapi[2099]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_time"
                                     :label="$t('getapi[2100]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="negative_flag"
                                     :label="$t('getapi[2096]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_account_person"
                                     :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Keep_account_time"
                                     :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Date"
                                     :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Keep_Person"
                                     :label="$t('getapi[1864]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Regist_Person"
                                     :label="$t('getapi[1747]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                    &lt;!&ndash; <el-table-column fixed="right"
                          :label="$t('basic.edit')"
                          width="60">
          <template slot-scope="scope">
            <el-button @click.native.prevent="editInfo(scope.row)"
                        type="text"
                        size="small">{{
                              $t('getapi[34]') }}
            </el-button>
          </template>
        </el-table-column> &ndash;&gt;
                </el-table>-->
            </li>

            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <!-- 右侧 -->
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:1000px;min-width:1000px">
                    <table>
                        <tr>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2095]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input v-model="dataDetail.head.order_no" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2097]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-select filterable v-model="dataDetail.head.receive_type_id" size="mini"
                                           class="mcolor"
                                           v-if="addoredit != 2 && dataDetail.head.receive_type_id!=12">
                                    <el-option v-for="item in ArrayReceiveType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                                <el-select filterable v-model="dataDetail.head.receive_type_id" size="mini"
                                           :disabled="true"
                                           v-if="addoredit == 2 && dataDetail.head.receive_type_id!=12">
                                    <el-option v-for="item in ArrayReceiveType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                                <el-input v-model="dataDetail.head.receive_type"
                                           size="mini" :disabled="true" v-if="dataDetail.head.receive_type_id==12">
                                </el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[2098]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <el-input
                                        :readonly="dataDetail.head.status == 1 ? true : false"
                                        :class="{'readO':dataDetail.head.status == 1}"
                                        v-model="dataDetail.head.keep_account_no"
                                        size="mini"
                                ></el-input>
                            </td>
                            <td style="width:80px;min-width:80px"><span>{{ $t('getapi[1864]') }}</span></td>
                            <td style="width:120px;min-width:120px">
                                <!--<el-input
                                        v-model="dataDetail.head.keep_person"
                                        type="text"
                                        @click.native.prevent="selectEmployee(1)"
                                        :disabled="dataDetail.head.status == 1 ? true : false"
                                        size="mini"
                                ></el-input>-->
                                <routejump :urlNo="6">
                                    <el-input
                                            v-model="dataDetail.head.keep_person"
                                            type="text"
                                            :disabled="dataDetail.head.status == 1 ? true : false"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectEmployee(1)"></i>

                                    </el-input>
                                </routejump>
                            </td>
                            <td style="width:80px;min-width:80px"></td>
                            <td style="width:120px;min-width:120px"></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1311]') }}</span></td>
                            <td>
                                <el-input v-model="dataDetail.head.keep_account_person" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[135]') }}</span></td>
                            <td>
                                <el-input v-model="dataDetail.head.keep_account_time" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td><span>{{ $t('getapi[2099]') }}</span></td>
                            <td><el-input v-model="dataDetail.head.receive_person" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[4470]') }}</span></td>
                            <td>
                                <routejump :urlNo="6">
                                    <el-input
                                            v-model="dataDetail.head.regist_person"
                                            type="text"
                                            :disabled="dataDetail.head.status == 1 ? true : false"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon"  slot="suffix" @click="selectEmployee(2)"></i>

                                    </el-input>
                                </routejump>
                            </td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[2100]') }}</span></td>
                            <td><el-input v-model="dataDetail.head.receive_time" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[1861]') }}</span></td>
                            <td><el-input :value="expStatus(dataDetail.head.status)" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[1862]') }}</span></td>
                            <td><el-input :value="expFinanceStatus(dataDetail.head.finance_status)" :readonly="true" class="readO"
                                           size="mini"></el-input></td>
                            <td><span v-if='showMoney'>{{ $t('getapi[1863]') }}</span></td>
                            <td><el-input v-if='showMoney' v-model="dataDetail.head.totalsum" type="text" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                        </tr>
                        <tr>
                            <td><span>{{ $t('getapi[1857]') }}</span></td>
                            <td><el-input v-model="dataDetail.head.finance_date" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[2203]') }}</span></td>
                            <td><el-input v-model="dataDetail.head.base_order_no" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                            <td><span>{{ $t('getapi[2096]') }}</span></td>
                            <td><el-checkbox v-model="dataDetail.head.negative_flag" disabled style="margin-left:0px;width:100px;"
                                             true-label="1"
                                             false-label="0"></el-checkbox></td>
                            <td><span>{{ $t('getapi[9026]') }}</span>  </td>
                            <td><el-input
                                    v-model="dataDetail.head.tempfield1"
                                    type="text"
                                    readonly
                                    :disabled="dataDetail.head.status == 0 ? false : true"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" v-if="dataDetail.head.status == 0" slot="suffix" @click="selectprosocode()"></i>
                            </el-input></td>
                            <td><span>{{ $t('getapi[9027]') }}</span></td>
                            <td><el-input v-model="dataDetail.head.tempfield2" :readonly="true" class="readO"
                                          size="mini"></el-input></td>
                        </tr>
                    </table>
                </div>
                <!--<div class="box" style="height: 130px;">
                    <div class="bbl">
                        <span>{{ $t('getapi[2095]') }}</span>
                        <el-input v-model="dataDetail.head.order_no" readonly style="width:100px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[2097]') }}</span>
                        <el-select filterable style="width:130px;" v-model="dataDetail.head.receive_type_id" size="mini"
                                   class="mcolor"
                                   v-if="addoredit != 2">
                            <el-option v-for="item in ArrayReceiveType" :key="item.Code" :label="item.Name"
                                       :value="item.Code"></el-option>
                        </el-select>
                        <el-select filterable style="width:130px;" v-model="dataDetail.head.receive_type_id" size="mini"
                                   :disabled="true"
                                   v-if="addoredit == 2">
                            <el-option v-for="item in ArrayReceiveType" :key="item.Code" :label="item.Name"
                                       :value="item.Code"></el-option>
                        </el-select>
                        <span>{{ $t('getapi[2098]') }}</span>
                        <el-input
                                :readonly="dataDetail.head.status == 1 ? true : false"
                                :class="{'readO':dataDetail.head.status == 1}"
                                v-model="dataDetail.head.keep_account_no"
                                style="width:100px;"
                                size="mini"
                        ></el-input>
                        <span>{{ $t('getapi[1864]') }}</span>

                        <el-input
                                v-model="dataDetail.head.keep_person"
                                type="text"
                                @click.native.prevent="selectEmployee(1)"
                                :disabled="dataDetail.head.status == 1 ? true : false"
                                style="width: 130px;"
                                size="mini"
                        ></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1311]') }}</span>
                        <el-input v-model="dataDetail.head.keep_account_person" :readonly="true" class="readO" style="width:100px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[135]') }}</span>
                        <el-input v-model="dataDetail.head.keep_account_time" :readonly="true" class="readO" style="width:130px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[2099]') }}</span>
                        <el-input v-model="dataDetail.head.receive_person" :readonly="true" class="readO" style="width:100px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[4470]') }}</span>
                        <el-input
                                v-model="dataDetail.head.regist_person"
                                type="text"
                                :disabled="dataDetail.head.status == 1 ? true : false"
                                @click.native.prevent="selectEmployee(2)"
                                style="width: 130px;"
                                size="mini"
                        ></el-input>
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[2100]') }}</span>
                        <el-input v-model="dataDetail.head.receive_time" :readonly="true" class="readO" style="width:100px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[1861]') }}</span>
                        <el-input :value="expStatus(dataDetail.head.status)" :readonly="true" class="readO" style="width:130px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[1862]') }}</span>
                        <el-input :value="expFinanceStatus(dataDetail.head.finance_status)" :readonly="true" class="readO"
                                  style="width:100px;" size="mini"></el-input>
                        &lt;!&ndash; 金额 &ndash;&gt;
                        <span v-if='showMoney'>{{ $t('getapi[1863]') }}</span>
                        <el-input v-if='showMoney' v-model="dataDetail.head.totalsum" type="text" style="width:130px;" :readonly="true" class="readO"
                                  size="mini"></el-input>
                        
                    </div>
                    <div class="bbl">
                        <span>{{ $t('getapi[1857]') }}</span>
                        <el-input v-model="dataDetail.head.finance_date" :readonly="true" class="readO" style="width:100px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[2203]') }}</span>
                        <el-input v-model="dataDetail.head.base_order_no" :readonly="true" class="readO" style="width:130px;"
                                  size="mini"></el-input>
                        <span>{{ $t('getapi[2096]') }}</span>
                        <el-checkbox v-model="dataDetail.head.negative_flag" disabled style="margin-left:0px;width:100px;"
                                     true-label="1"
                                     false-label="0"></el-checkbox>
                       
                        <span>{{ $t('getapi[9026]') }}</span>                        
                        <el-input
                                v-model="dataDetail.head.tempfield1"
                                type="text"
                                readonly
                                :disabled="dataDetail.head.status == 0 ? false : true"
                                size="mini"
                                style="width:130px;"
                        >
                            <i  class="el-icon-edit el-input__icon" v-if="dataDetail.head.status == 0" slot="suffix" @click="selectprosocode()"></i>
                        </el-input>
                        <span>{{ $t('getapi[9027]') }}</span>
                        <el-input v-model="dataDetail.head.tempfield2" :readonly="true" class="readO" style="width:130px;"
                                  size="mini"></el-input>
                    </div>
                </div>-->
                <!--右下-->
                <el-row>
                    <div class="box" style="margin-top: 0px">
                            <el-button type="primary" size="mini" @click="addMaterials('')"
                                       :disabled="!btn.add">{{ $t('getapi[6092]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.rowdel">{{ $t('getapi[1522]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="negative" :disabled="!btn.negative">{{
                                $t('getapi[2107]') }}
                            </el-button>
                    </div>
                    <el-table
                            id="xdetilpane-0"
                            :data="dataDetail.line"
                            v-loading="dloading"
                            header-row-class-name="headerclass"
                            :highlight-current-row="true"
                            stripe
                            border
                            :height="tableHeight - 170"
                            size="mini"
                            @selection-change="handleSelectionChange"
                            :row-class-name="tableRowClassName"
                            style="width: 100%; margin-top:2px"
                            @sort-change="sortChange"
                            ref="singleTable1"
                    >
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column show-overflow-tooltip width="60" prop="line_no" :label="$t('getapi[1425]')" sortable align="right">
                        </el-table-column>
                        <el-table-column prop="part_code" :label="$t('getapi[112]')" sortable width="120">
                            <template scope="scope">
                                <el-input v-if="editif" v-model="scope.row.part_code" type="text"
                                          readonly size="mini">
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="addMaterials(scope)"></i>
                                </el-input>
                                <span v-if="!editif">{{ scope.row.part_code }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
                        <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')" sortable></el-table-column>
                        <el-table-column show-overflow-tooltip prop="specification" :label="$t('getapi[4187]')" sortable></el-table-column>
                        <el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')" sortable></el-table-column>
                        <el-table-column prop="batch_no" :label="$t('getapi[1763]')" sortable>
                            <template scope="scope">
                                <el-input v-if="editif" size="mini" v-model="scope.row.batch_no" :disabled="scope.row.batch_no == '*'" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                <span v-if="!editif">{{ scope.row.batch_no }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sequence_no" :label="$t('getapi[1764]')" sortable>
                            <template scope="scope">
                                <el-input v-if="editif" size="mini" v-model="scope.row.sequence_no" :disabled="scope.row.sequence_no == '*'" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                <span v-if="!editif">{{ scope.row.sequence_no }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="receive_qty" :label="$t('getapi[3101]')" sortable width="100">
                            <template scope="scope">
                                <el-input v-if="editif" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_qty"
                                          @change="sum(scope)"></el-input>
                                <span v-if="!editif">{{ scope.row.receive_qty }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cargo_position" :label="$t('getapi[4522]')" sortable width="120">
                            <template scope="scope">
                                <el-input v-if="editif" v-model="scope.row.cargo_position" type="text" readonly
                                          size="mini">
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="getInvCargo(scope)"></i>
                                </el-input>
                                <span v-if="!editif">{{ scope.row.cargo_position }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-footer-overflow field="part_groupid"   v-if="false"></el-table-column>                            
                        <el-table-column field="freevalue" :label="$t('getapi[8958]')" sortable width="100">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.freevalue" type="text" readonly
                                            size="mini" v-if="dataDetail.head.status == 0 && freevalue">
                                    <i class="el-icon-edit el-input__icon" slot="suffix"
                                        @click="getpartgroup(scope)"></i>
                                </el-input>
                                <span v-if="dataDetail.head.status != 0 ">{{scope.row.freevalue}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="unit_price" :label="$t('getapi[1410]')" sortable width="100">
                            <template scope="scope">
                                <!-- <el-input v-if="editprice" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.unit_price"
                                          @change="unitpricesum(scope)"></el-input> -->
                                <span>{{ scope.row.unit_price }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column align="right" prop="line_net_total_amount" :label="$t('getapi[2102]')" sortable width="100">
                            <template scope="scope">
                                <el-input v-if="editif" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.line_net_total_amount"
                                          @change="pricebytotalamount(scope)"></el-input>
                                <span v-if="!editif">{{ scope.row.line_net_total_amount }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column v-if='showMoney' show-overflow-tooltip align="right" prop="unit_price"
                                         :label="$t('getapi[1410]')" sortable></el-table-column> -->
                        <!-- <el-table-column v-if='showMoney' show-overflow-tooltip align="right" prop="line_net_total_amount"
                                         :label="$t('getapi[2102]')" sortable></el-table-column> -->
                        <el-table-column v-if="editprice" align="right" prop="receive_adjust_material_cost" :label="$t('getapi[5133]')" sortable width="100">
                            <template scope="scope">
                                <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_adjust_material_cost"
                                          @change="costsum(scope)"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="editprice" align="right" prop="receive_adjust_man_cost" :label="$t('getapi[5134]')" sortable width="100">
                            <template scope="scope">
                                <el-input  size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_adjust_man_cost"
                                          @change="costsum(scope)"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="editprice" align="right" prop="receive_adjust_charge_cost" :label="$t('getapi[5135]')" sortable width="100">
                            <template scope="scope">
                                <el-input  size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_adjust_charge_cost"
                                          @change="costsum(scope)"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[3100]')" sortable></el-table-column>
                        <el-table-column prop="assist_receive_qty" :label="$t('getapi[2109]')" sortable align="right" width="100">
                            <template scope="scope">
                                <el-input v-if="editif && scope.row.assist_measureunit != ''" size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                          v-model="scope.row.assist_receive_qty" @change="getQty(scope)"></el-input>
                                <span v-if="!editif || scope.row.assist_measureunit == ''">{{ scope.row.assist_receive_qty }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="assist_measureunit"
                                         :label="$t('getapi[2110]')" sortable></el-table-column>

                        <el-table-column prop="remark" :label="$t('getapi[143]')" sortable>
                            <template scope="scope">
                                <el-input v-if="editif" size="mini" v-model="scope.row.remark"></el-input>
                                <span v-if="!editif">{{ scope.row.remark }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </li>
        </ul>

        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="InvReceieveManufactureViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[973]')" queryData="InvReceieveManufactureViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!-- 详情页面 -->
        <!-- <inv-in-manager :isVisible="isVisible"
                ref="order"
                @getdetail="getdetail"></inv-in-manager> -->
        <!--人员 -->
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="inputemp"></employee>-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :selectType="3"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee"
                  ref="inputemp"></selector>

        <!-- 新增物料弹框 -->
        <!--<OM :isVisible="materialsVisible" @addmaterials="addmaterials" ref="addmaterials"></OM>-->
        <selector :isVisible="materialsVisible" :selectType="6" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterials"></selector>

        <!-- 货位 -->
        <!--<invcargo :isVisible="cargoVisible" @getinvcargo="getinvcargo" ref="invcargo"></invcargo>-->
        <selector :isVisible="cargoVisible" :isBatch=false :isSplitPage=true
                  :postUrl="'/Inv/MaterialIn/GetInvInCargoPPopupList'" @callback="getinvcargo"
                  ref="invcargo"></selector>
        <!-- 自由项 -->
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupView'" @callback="partgroup"
                  ref="partgroup"></selector>
        <selector :isVisible="false" :isBatch="false"  :isSplitPage=true
                  :postUrl="'/Inv/MaterialIn/GetProSoPopuView'" @callback="getprosocode" ref="prosocode"></selector>
        
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import InvInManager from './InvInManager.vue';
    import { Loading } from 'element-ui';
    export default {
        // components: { InvInManager },
        name: 'InvInView',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                editif: false, //是否
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('InvInView'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dloading:false,//右边明细表 加载状态
                isShowEdit: false, // 是否显示编辑页面
                // dataDetailM: {
                //   Head: {},
                //   Lists: []
                // }, // 编辑页面数据详情
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                //**********右侧页面数据参数******
                user: '',
                dataDetail: {
                    head: {},
                    line: []
                }, // 数据详情
                oldDataDetail:'',
                ArrayReceiveType: [], // 入库类型
                // ArrayTransMode: [], // 运输方式
                employeeVisible: false, // 是否显示人员列表
                getEmployeeType: '', // 当前是获取什么类型人员
                materialsVisible: false,
                dataChecked: [],
                addoredit: -1,
                rowindex: -1,
                cargoVisible: false,
                btn: {
                    //新增行
                    add: false,
                    //执行单据
                    audit: false,
                    //执行记账
                    finance: false,
                    //生成红字
                    negative: false,
                    //行删除
                    rowdel: false
                },
                Order_No: '', // 数据唯一号
                dataDetailLineNo: 1,
                selectData:[],
                showMoney:false,
                editprice:false,
                oldrow: '',
                iscontinuedblclick:true,
                timeId: null,
                //自由项
                freevalue: false,
                //自由项配置
                freeConfig:0,
                onlyprice:0,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        created:function(){
            //console.log('create------------')
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('InvInView', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.PlanTypeArray = Array.methods.getPlanType();
            that.ArrayReceiveType = Array.methods.getReceieveType();
            that.user = that.userData.username;
            that.freeConfig=Array.methods.getSysConfig('A104');
            that.onlyprice=Array.methods.getSysConfig('A110');
            ///物料自由项是否启用
            if(that.freeConfig== 1){
                that.freevalue = true
            }
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('InvReceieveManufactureViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[973]"),this.$t("getapi[15]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                let limits = 1;
                if(!this.$limits.menuvisible("plv2", 78, 1)) {
                    var value = that.$limits.newOperationAuthorityView('plv2', 77, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 78, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                    }
                    if (that.$limits.authority('plv2', 78, 1) == 2) {
                        if (that.$limits.authority('plv3', 78,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 78,1) == 1) {

                            if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {

                                if (that.dataDetail.head.status == 1) {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,preview,print');
                                } else {
                                    if (that.$limits.authority('plv4', 39,1) == 1) {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,preview,print');
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,preview,print');
                                    }
                                    if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                                        if (that.dataDetail.head.status != 1) {
                                            that.$refs.SetBtn.SetOneBtnEnable('execute',true);
                                        }
                                    }
                                    else{
                                        that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                                    }
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                                    if (that.dataDetail.head.status != 1) {
                                        that.$refs.SetBtn.SetOneBtnEnable('execute',true);
                                    }
                                }
                                else{
                                    that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                                }
                            }
                            limits = 2;
                        }
                        if (that.$limits.authority('plv3', 78,1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                                if (that.dataDetail.head.status == 1) {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,preview,print');
                                } else {
                                    if (that.$limits.authority('plv4', 39, 1) == 1) {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,preview,print');
                                    } else {
                                        that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,preview,print');
                                    }

                                    if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                                        if (that.dataDetail.head.status != 1) {
                                            that.$refs.SetBtn.SetOneBtnEnable('execute',true);
                                        }
                                    }
                                    else{
                                        that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                                    }
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                                    if (that.dataDetail.head.status != 1) {
                                        that.$refs.SetBtn.SetOneBtnEnable('execute',true);
                                    }
                                }
                                else{
                                    that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                                }
                            }
                            limits = 3;
                        }
                    }
                    //金额显影
                    if (that.$limits.authority('plv4', 316, 1) == 0) {
                        that.showMoney = false;
                    } else {
                        that.showMoney = true;
                    }
                    //单价是否可以编辑
                    if(that.onlyprice==1){
                        that.editprice=true;
                    }
                    else{
                        that.editprice=false;
                    }
                }
                that.$refs.SetBtn.InputBtnRight('T09_MRNote');//查询状态，导入按钮也亮！！！！按老的ERP

                if(limits==-1||limits==1)that.closeAllRightButton();
				else that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.rowdel = false;
                if(that.$limits.fnIsEmpty(that.dataDetail.head.order_no)){
                    if(that.selectData.length>0){
                        that.btn.rowdel = true;
                    }
                }
                else
                {   //行删除
                    if (that.$limits.authority('plv4', 60, 1) == 0) {
                        that.btn.rowdel = false;
                    }
                    if (that.$limits.authority('plv4', 60, 1) == 1) {
                        if (that.dataDetail.head.status == 1) {
                            that.btn.rowdel = false;
                        } else {
                            if(that.selectData.length>0){
                                that.btn.rowdel = true;
                            }
                        }
                    }
                }

                if (that.dataDetail.head.status == 1) {//关闭状态的订单
                    that.btn.add = false;
                    if (that.dataDetail.head.negative_flag == 0 && that.dataDetail.head.receive_type_id!=12) {
                        that.btn.negative = true;
                    } else {
                        that.btn.negative = false;
                    }
                } else {
                    that.btn.add = true;
                    //红字单据 不能增加物料
                    if(that.dataDetail.head.negative_flag==1) that.btn.add = false;
                    that.btn.negative = false;
                    
                        if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                            if (that.$limits.authority('plv4', 39, 1) == 0) {
                                that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                            }
                            if (that.$limits.authority('plv4', 39, 1) == 1) {
                                that.$refs.SetBtn.SetOneBtnEnable('execute',true);
                            }
                        } 
                        else {
                            that.$refs.SetBtn.SetOneBtnEnable('execute',false);
                        }
                }

                if (that.dataDetail.head.finance_status == 0) {
                    if (!that.$limits.fnIsEmpty(that.dataDetail.head.order_no)) {
                        //核算
                        that.btn.finance = true;
                    }
                    else{
                        that.btn.finance = false;
                    }
                } else {
                    that.btn.finance = false;
                }
                

            },
            closeAllRightButton(){
			let that =this;
			that.btn.add=false;
			that.btn.audit=false;
			that.btn.finance=false;
            that.btn.negative=false;
            that.btn.rowdel=false;
			},
            selectprosocode() {
                let that = this;
                that.$refs.prosocode.clearInput(true);
            },
            getprosocode(data) {
                let that = this;
                that.dataDetail.head.tempfield1 = data.so_code;
                that.dataDetail.head.tempfield2 = data.schedule_no;               
            },
            //查询右侧数据
            edits(e) {
                let that = this;
                if(that.Order_No == e.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 78, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.line.length;i++){
                        delete datacopy.line[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = e
                                that.Order_No = e.Order_No;
                                let parm = {
                                    Code: e.Order_No,
                                    List: []
                                };
                                that.getdlist(parm);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = e
                        that.Order_No = e.Order_No;
                        let parm = {
                            Code: e.Order_No,
                            List: []
                        };
                        that.getdlist(parm);
                    }
                }, 100);
            },
                      
            getpartgroup(data) {
                let that = this;
                that.rowindex = data.$index;
                let param = {
                    part_code:that.dataDetail.line[that.rowindex].part_code,
                    part_version:that.dataDetail.line[that.rowindex].part_version,
                };
                if (that.freeConfig == 1) {
                    that.$refs.partgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            partgroup(data){
                let that = this;
                that.dataDetail.line[that.rowindex].freevalue = data.freevalue;
                that.dataDetail.line[that.rowindex].part_groupid = data.exclusively_id;                
            },
            getdlist(data) {
                let that = this;
                if (data.Code == '') {
                    that.addoredit = 1;
                    that.dataDetail.head = {
                        order_no: '',
                        status:0,
                        order_status: '生成',
                        receive_type_id: null,
                        keep_account_no: '',
                        receive_person: '',
                        receive_time: '',
                        keep_account_person: '',
                        keep_account_time: '',
                        remark: '',
                        finance_status: '',
                        finance_date: '',
                        keep_person: that.user,
                        regist_person: that.user,
                        negative_flag: 0,
                        totalsum: 0,
                        base_order_no: '',
                        concurrent_time: '',
                        isok:0,
                        tempfield1:'',
                        tempfield2:''
                    };
                    that.dataDetail.line = [];
                    that.editif = true;
                    that.oldDataDetail = JSON.stringify(that.dataDetail)
                } else {
                    that.addoredit = 2;
                    that.getDetail(data);
                    that.authority();
                }
            },
            getDetail(data) {
                let that = this;
                that.dloading = true;
                let parm = data;
                parm.LangType = that.$processdata.getLang()
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Inv/MaterialIn/InvReceieveDetail', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.head = res.DataContent.head[0];
                        that.dataDetail.line = res.DataContent.line;
                        that.dataDetail.head.negative_flag = that.dataDetail.head.negative_flag.toString()
                        if (that.dataDetail.head.status == 1) that.editif = false;
                        else that.editif = true;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(0)
                        })
                    }
                    else{
                        that.confirmAdd();
                    }
                    that.dloading = false;
                    loadingInstance.close()
                });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            selectEmployee(type) {
                let that = this;
                if (!that.editif) return;
                that.employeeVisible = true
                that.getEmployeeType = type
                this.$refs.inputemp.clearInput(true);
            },
            // 获取
            getemployee(data) {
                let that = this;
                if (that.getEmployeeType == 1) {
                    that.dataDetail.head.keep_person = data.name;
                } else if (that.getEmployeeType == 2) {
                    that.dataDetail.head.regist_person = data.name
                }
            },

            addMaterials(row) {
                let that = this;
                that.rowindex = row.$index;
                that.materialsVisible = true;
                that.$refs.addmaterials.clearInputFromFunc(that.materialsVisible, false, 6);
            },
            addmaterials(data) {
                let that = this;
                // console.log(data)
                if (that.rowindex < that.dataDetail.line.length && that.rowindex != -1) {
                    that.dataDetail.line[that.rowindex].exclusively_id = '';
                    that.dataDetail.line[that.rowindex].relation_order_no = '';
                    that.dataDetail.line[that.rowindex].line_no = that.dataDetail.line.length + 1;
                    that.dataDetail.line[that.rowindex].batch_no = data.islotnumbertrace == false?'*':'';
                    that.dataDetail.line[that.rowindex].sequence_no = data.issequencetrace == false?'*':'';
                    that.dataDetail.line[that.rowindex].partid = data.exclusively_id
                    that.dataDetail.line[that.rowindex].part_code = data.part_code;
                    that.dataDetail.line[that.rowindex].part_name = data.part_name;
                    that.dataDetail.line[that.rowindex].part_version = data.part_version;
                    that.dataDetail.line[that.rowindex].model = data.part_model;
                    that.dataDetail.line[that.rowindex].specification = data.part_spec;
                    that.dataDetail.line[that.rowindex].part_stuff = data.part_stuff;
                    that.dataDetail.line[that.rowindex].receive_qty = 0;
                    that.dataDetail.line[that.rowindex].measureunit = data.part_master_unit;
                    that.dataDetail.line[that.rowindex].receive_price = '';
                    that.dataDetail.line[that.rowindex].cargo_position = data.cargoposition_code;
                    that.dataDetail.line[that.rowindex].workproc_id = '';
                    that.dataDetail.line[that.rowindex].line_status = '';
                    that.dataDetail.line[that.rowindex].assist_measureunit = data.part_assist_unit;
                    that.dataDetail.line[that.rowindex].assist_receive_qty = 0;
                    that.dataDetail.line[that.rowindex].remark = '';
                    that.dataDetail.line[that.rowindex].line_net_total_amount = 0;
                    that.dataDetail.line[that.rowindex].unit_price = data.inv_cost;
                    that.dataDetail.line[that.rowindex].master_assist_rate = data.master_assist_rate
                    that.dataDetail.line[that.rowindex].part_groupid = '';
                    that.dataDetail.line[that.rowindex].freevalue = '';
                } else {
                    that.dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.line.length; i++) {
                        if (that.dataDetail.line[i].line_no >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.line[i].line_no + 1
                        }
                    }
                    that.dataDetail.line = [
                        ...that.dataDetail.line,
                        {
                            exclusively_id: '',
                            relation_order_no: '',
                            line_no: that.dataDetailLineNo++,
                            batch_no: data.islotnumbertrace == false?'*':'',
                            sequence_no: data.issequencetrace == false?'*':'',
                            partid: data.exclusively_id,
                            part_code: data.part_code,
                            part_name: data.part_name,
                            part_version: data.part_version,
                            model: data.part_model,
                            specification: data.part_spec,
                            part_stuff: data.part_stuff,
                            receive_qty: 0,
                            measureunit: data.part_master_unit,
                            receive_price: '',
                            cargo_position: data.cargoposition_code,
                            workproc_id: '',
                            line_status: '',
                            assist_measureunit: data.part_assist_unit,
                            assist_receive_qty: 0,
                            remark: '',
                            line_net_total_amount: 0,
                            unit_price: data.inv_cost,
                            master_assist_rate: data.master_assist_rate,
                            part_groupid : '',
                            freevalue : '',
                        }
                    ];
                }
                that.btnauthority();
            },
            getInvCargo(row) {
                let that = this;
                that.rowindex = row.$index;
                that.cargoVisible = true;
                let parm = {
                    negative_flag: that.dataDetail.head.negative_flag,
                    part_code: row.row.part_code,
                    part_version: row.row.part_version,
                    batch_no: row.row.batch_no,
                    sequence_no: row.row.sequence_no
                };
                that.$refs.invcargo.clearInput(that.cargoVisible, parm);
            },
            //获取货位信息
            getinvcargo(data) {
                let that = this;
                that.dataDetail.line[that.rowindex].cargo_position = data.cargoposition_code;
                let parm = {
                    part_code: that.dataDetail.line[that.rowindex].part_code,
                    part_version: that.dataDetail.line[that.rowindex].part_version,
                    cargo_position: that.dataDetail.line[that.rowindex].cargo_position,
                    isdefault: 0
                }
                that.$http.urlpost('/Inv/MaterialIn/GetSetDefaultPosition', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let parm1 = {
                                    part_code: that.dataDetail.line[that.rowindex].part_code,
                                    part_version: that.dataDetail.line[that.rowindex].part_version,
                                    cargo_position: that.dataDetail.line[that.rowindex].cargo_position,
                                    isdefault: 1
                                }
                                that.$http.urlpost('/Inv/MaterialIn/GetSetDefaultPosition', parm1, function (res1) {
                                    if (res1.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                    }
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            excute() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('execute', false);
               
                that.dataDetail.head.isok = 0
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Inv/MaterialIn/InvReceieveExcute', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.Order_No != '') {
                            let parm = {
                                Code: that.Order_No,
                                IID: '',
                                Name: '',
                                Status: ''
                            };
                            that.getDetail(parm);
                        }
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.dataDetail.head.isok = 1
                                let parm1 = that.dataDetail
                                parm1.LangType = that.$processdata.getLang()
                                that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                                that.$http.urlpost('/Inv/MaterialIn/InvReceieveExcute', parm, function (res1) {
                                    that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                                    if(res1.Success == 1){
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                        if (that.Order_No != '') {
                                            let parm = {
                                                Code: that.Order_No,
                                                IID: '',
                                                Name: '',
                                                Status: ''
                                            };
                                            that.getDetail(parm);
                                        }
                                    }
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    // that.authority();
                });
            },
            finance() {
                let that = this;
                let parm = that.dataDetail.head;
                that.$http.urlpost('/Inv/MaterialIn/UpdateFinanceStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            negative() {
                let that = this;
                let parm = that.dataDetail.head;
                that.$http.urlpost('/Inv/MaterialIn/CreateNegativeOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.Order_No = res.UniqueNum
                         let parm = {
                            Code: res.UniqueNum,
                            IID: '',
                            Name: '',
                            Status: ''
                        };
                        that.getDetail(parm);
                    }
                });
                that.authority();
            },
           /* handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].exclusively_id);
                }
            },*/
            // deleteLine(){
            //     let that = this
            //     let arr = that.dataDetail.line.filter(item => {
            //         return that.dataChecked.every(item2 => {
            //             return item.exclusively_id != item2
            //         })
            //     })
            //     that.dataDetail.line = arr;
            // },
            deleteline(row) {
                let that = this;
                that.dataDetail.line.splice(row.$index, 1);
                // if(that.IsMain){
                //     that.dataSetMain.splice(row.$index,1);
                // }else{
                //     that.dataSetAssist.splice(row.$index,1);
                // }
            },
            expNegativeStatus(val) {
                return val == 1 ? true : false;
            },
            expStatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[3557]')//'关闭';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[3607]')//'审核';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            sum(row) {
                let that = this;
                that.rowindex = row.$index;
                that.dataDetail.line[that.rowindex].receive_qty = parseFloat(that.dataDetail.line[that.rowindex].receive_qty);
                that.dataDetail.line[that.rowindex].line_net_total_amount = that.countNum(that.dataDetail.line[that.rowindex].unit_price , that.dataDetail.line[that.rowindex].receive_qty).toFixed(4);
            },
            unitpricesum(row) {
                let that = this;
                that.rowindex = row.$index;
                that.dataDetail.line[that.rowindex].unit_price = parseFloat(that.dataDetail.line[that.rowindex].unit_price);
                that.dataDetail.line[that.rowindex].line_net_total_amount = that.countNum(that.dataDetail.line[that.rowindex].unit_price , that.dataDetail.line[that.rowindex].receive_qty).toFixed(4);
            },
            costsum(row) {
                let that = this;
                that.rowindex = row.$index;
                that.dataDetail.line[that.rowindex].line_net_total_amount =that.costAddcountNum(that.costAddcountNum(that.dataDetail.line[that.rowindex].receive_adjust_material_cost,that.dataDetail.line[that.rowindex].receive_adjust_man_cost).toFixed(4),that.dataDetail.line[that.rowindex].receive_adjust_charge_cost).toFixed(4);
                that.dataDetail.line[that.rowindex].unit_price =(parseFloat(that.dataDetail.line[that.rowindex].line_net_total_amount)/ parseFloat(that.dataDetail.line[that.rowindex].receive_qty)).toFixed(4);
            },            
            pricebytotalamount(row) {
                let that = this;
                that.rowindex = row.$index;                
                if(parseFloat(that.dataDetail.line[that.rowindex].receive_qty)>0){
                    that.dataDetail.line[that.rowindex].unit_price = (parseFloat(that.dataDetail.line[that.rowindex].line_net_total_amount)/parseFloat(that.dataDetail.line[that.rowindex].receive_qty)).toFixed(6);
                    that.dataDetail.line[that.rowindex].receive_adjust_material_cost=0;
                    that.dataDetail.line[that.rowindex].receive_adjust_man_cost=0;
                    that.dataDetail.line[that.rowindex].receive_adjust_material_cost=0;
                }
            },
            
            costAddcountNum (num1, num2) {
                num1 == undefined ? num1 = 0 : ''
                num2 == undefined ? num2 = 0 : ''
                var sq1, sq2, m;
                try {
                    sq1 = num1.toString().split(".")[1].length;
                }
                catch (e) {
                    sq1 = 0;
                }
                try {
                    sq2 = num2.toString().split(".")[1].length;
                }
                catch (e) {
                    sq2 = 0;
                }
                m = Math.pow(10, Math.max(sq1, sq2));
                return ((num1 * m) + (num2 * m)) / (m);
            },

            countNum (num1, num2) {
                num1 == undefined ? num1 = 0 : ''
                num2 == undefined ? num2 = 0 : ''
                var sq1, sq2, m;
                try {
                    sq1 = num1.toString().split(".")[1].length;
                }
                catch (e) {
                    sq1 = 0;
                }
                try {
                    sq2 = num2.toString().split(".")[1].length;
                }
                catch (e) {
                    sq2 = 0;
                }
                m = Math.pow(10, Math.max(sq1, sq2));
                return ((num1 * m) * (num2 * m)) / (m*m);
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('InvInView',val)
                this.intidata();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.intidata();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'InvReceieveManufactureViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.pageIndex = 1;
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.intidata();
            },

            // 数据一览
            intidata() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    Param: datac
                };
                that.$http.urlpost('/Inv/MaterialIn/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            /*editInfo(row) {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.line.length;i++){
                    delete datacopy.line[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm('数据已发生变更还未保存，是否切换？', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    })
                        .then(() => {
                            that.oldrow = row
                            that.isShowEdit = true;
                            that.isEdit = true;
                            that.Order_No = row.Order_No
                            let parm = {
                                Code: row.Order_No,
                                List: []
                            };
                            this.$refs.order.clearInput(this.isShowEdit, parm);
                        })
                        .catch(() => {
                            that.$refs.singleTable.setCurrentRow(that.oldrow);
                        });
                } else {
                    that.oldrow = row
                    that.isShowEdit = true;
                    that.isEdit = true;
                    that.Order_No = row.Order_No
                    let parm = {
                        Code: row.Order_No,
                        List: []
                    };
                    this.$refs.order.clearInput(this.isShowEdit, parm);
                }
            },*/

            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.line.length;i++){
                    delete datacopy.line[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.editif = true;
                let parm = {
                    Code: '',
                    List: []
                };
                that.getdlist(parm);
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.line.length;i++){
                    delete datacopy.line[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.intidata();
                            console.log("刷新:"+that.Order_No)
                            if(!that.$limits.fnIsEmpty(that.Order_No)){
                                let parm = {
                                    Code: that.Order_No,
                                    IID: '',
                                    Name: '',
                                    Status: ''
                                };
                                that.getDetail(parm);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.intidata();
                    console.log("刷新1:"+that.Order_No)
                    if(!that.$limits.fnIsEmpty(that.Order_No)){
                        let parm = {
                            Code: that.Order_No,
                            IID: '',
                            Name: '',
                            Status: ''
                        };
                        that.getDetail(parm);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            impx() {
                let item = {
                    //label: '材料入库导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/11',
                    url: '/exp/11',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/11'});
                this.$store.commit('selectMenu', item);
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Inv/MaterialIn/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "InvReceieveManufactureViewInfo",
                    fromname: that.$t('getapi[973]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            editInfo1() {
            },
            editInfo2() {
            },
            editInfo3() {
            },
            selectRow(row) {
                let that = this;
                that.Order_No = row.Order_No;
            },
            save() {
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.head.receive_type_id)){
                    that.$message.warning(that.$t('getapi[8620]'))//'请选择入库类型！'
                    return
                }
                let parm = {
                    head: that.dataDetail.head,
                    line: that.dataDetail.line,
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost('/Inv/MaterialIn/InvReceieveSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.Order_No = res.UniqueNum
                        let parm = {
                            Code: res.UniqueNum,
                            IID: '',
                            Name: '',
                            Status: ''
                        };
                        that.getDetail(parm);
                    } 
                    // else {
                    //     that.$message.error(res.Msg);
                    // }
                });
            },
            print() {
                //判断状态
                let that = this;
                if (that.Order_No == 0) return;
                that.dloading = true;
                let parm = {
                    po_no: that.Order_No,
                    TemplateName: '09材料入库单.xlsx'
                };
                that.$http.urlpost('/Print/MRPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    } 
                    that.dloading = false;
                });
            },
            //根据次数量获取数量
            getQty(row){
                let that = this
                let index = row.$index;
                that.dataDetail.line[index].receive_qty = (that.dataDetail.line[index].master_assist_rate * that.dataDetail.line[index].assist_receive_qty).toFixed(4)
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.head.order_no,
                            concurrent_time:that.dataDetail.head.concurrent_time,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Inv/MaterialIn/DelInvReceieve', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.intidata();
                                that.confirmAdd();
                                that.Order_No = ''
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority();
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_status: that.dataDetail.head.order_status,
                            order_no: that.dataDetail.head.order_no,
                            concurrent_time:that.dataDetail.head.concurrent_time,
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.line.splice(that.selectData[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.selectData[i].exclusively_id,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Inv/MaterialIn/DelInvRow', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    let parm = {
                                        Code: that.Order_No,
                                        IID: '',
                                        Name: '',
                                        Status: ''
                                    };
                                    that.getDetail(parm);
                                }
                                else{
                                    let parm = {
                                        Code: that.Order_No,
                                        IID: '',
                                        Name: '',
                                        Status: ''
                                    };
                                    that.getDetail(parm);
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 排序
            sortChange(column){
                let that = this
                that.$processdata.sortChange(column,that.dataDetail.line)
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 78,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.line.length;i++){
                    delete datacopy.line[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 20px;
                width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
